import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { MODERN_COLORS, MODERN_RADIUS, MODERN_SHADOWS } from './tokens';

export const ModernFloatingActionsBar = ({
  selectedCount = 0,
  totalCount,
  children,
  sx = {},
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        position: { xs: 'static', md: 'sticky' },
        left: 0,
        right: 0,
        bottom: 16,
        zIndex: 2,
        borderRadius: MODERN_RADIUS.card,
        px: 2.5,
        py: 1.8,
        mt: { xs: 3, md: 0 },
        bgcolor: 'rgba(255, 255, 255, 0.96)',
        backdropFilter: 'blur(10px)',
        border: `1.5px solid ${MODERN_COLORS.borderCyan}`,
        boxShadow: MODERN_SHADOWS.floatingBar,
        ...sx,
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          alignItems="center"
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
            <Box
              sx={{
                bgcolor: MODERN_COLORS.primary,
                color: '#ffffff',
                px: 1.5,
                py: 0.35,
                borderRadius: MODERN_RADIUS.pill,
                fontSize: '0.75rem',
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              {selectedCount} seleccionados
            </Box>
            {totalCount !== undefined && (
              <Typography variant="body2" sx={{ color: MODERN_COLORS.textMuted, fontSize: '0.8rem' }}>
                de {totalCount} registros
              </Typography>
            )}
          </Stack>
        </Stack>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          alignItems="center"
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          {children}
        </Stack>
      </Stack>
    </Paper>
  );
};

ModernFloatingActionsBar.propTypes = {
  selectedCount: PropTypes.number,
  totalCount: PropTypes.number,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default ModernFloatingActionsBar;
